import { useState, useMemo, useCallback } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ENABLE_TICKET_PROPERTIES } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import useTogglePayments from 'FormsUI/components/hooks/payment/useTogglePayments';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TurnOnTicketsHint = ({
  enableTickets = () => {},
  ticketToggleEnabled = false
}) => {
  const [shouldShowAlert, setShouldShowAlert] = useState(!ticketToggleEnabled);
  const {
    isPaymentsOn,
    togglePaymentsOn
  } = useTogglePayments();
  const handleEnableTickets = useCallback(() => {
    trackEditorInteraction(ENABLE_TICKET_PROPERTIES);
    enableTickets();
  }, [enableTickets]);
  const TitleText = useMemo(() => isPaymentsOn ? /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: () => togglePaymentsOn(false),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "editor.form.properties.ticketsHintPayments"
    })
  }) : /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: handleEnableTickets,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "editor.form.properties.ticketsHint"
    })
  }), [handleEnableTickets, togglePaymentsOn, isPaymentsOn]);
  return shouldShowAlert ? /*#__PURE__*/_jsx(Alert, {
    type: "tip",
    use: "inline",
    closeable: true,
    cursor: "pointer",
    marginBlock: "300",
    onClose: () => setShouldShowAlert(false),
    titleText: TitleText
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
export default TurnOnTicketsHint;